/** B-07P — Razorpay checkout helpers (publishable key only on client) */

export const MAX_PAYMENT_RETRIES = 3;
export const PAYMENT_EXPIRY_MS = 15 * 60 * 1000;

export function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.Razorpay) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Razorpay checkout'));
    document.body.appendChild(script);
  });
}

export function getRazorpayKeyId() {
  return process.env.REACT_APP_RAZORPAY_KEY_ID || '';
}

export function buildRazorpayOptions({
  key,
  amountInPaise,
  currency = 'INR',
  razorpayOrderId,
  orderId,
  userPhone,
  onSuccess,
  onDismiss,
  onFailure,
}) {
  return {
    key,
    amount: amountInPaise,
    currency,
    order_id: razorpayOrderId,
    name: 'SparePe',
    description: `Parts Order ${orderId || ''}`.trim(),
    handler: onSuccess,
    prefill: userPhone ? { contact: userPhone } : {},
    theme: { color: '#1F4E8C' },
    modal: {
      ondismiss: onDismiss,
    },
    notes: orderId ? { sparepeOrderId: orderId } : {},
  };
}

export function readPendingCheckout(locationState) {
  if (locationState?.razorpayCheckout) return locationState.razorpayCheckout;
  try {
    const raw = localStorage.getItem('pendingRazorpayCheckout');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingCheckout() {
  localStorage.removeItem('pendingRazorpayCheckout');
}

export function shouldShowUpiCollect(retryCount) {
  return retryCount >= MAX_PAYMENT_RETRIES;
}

export function formatExpiryCountdown(expiresAt) {
  if (!expiresAt) return null;
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return '0:00';
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
